var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.31,
    height: 10.048,
    viewBox: "0 0 21.31 10.048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_221",
    "data-name": "Gruppe 221",
    transform: "translate(-0.025 0.025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_220",
    "data-name": "Gruppe 220"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_58",
    "data-name": "Pfad 58",
    d: "M15.359,10.023a.875.875,0,0,1-.466-1.616l4.342-2.725L16.509,1.341A.876.876,0,0,1,17.961.36c.011.016.021.033.031.05l3.189,5.083A.875.875,0,0,1,20.906,6.7l-5.083,3.19A.867.867,0,0,1,15.359,10.023Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_59",
    "data-name": "Pfad 59",
    d: "M20.44,6.833a.88.88,0,0,1-.3-.055,31.037,31.037,0,0,0-18.957,0,.875.875,0,0,1-.609-1.64,32.739,32.739,0,0,1,20.176,0,.875.875,0,0,1-.306,1.7Z",
    fill: "#141414"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrow);
export default __webpack_public_path__ + "static/media/icon-arrow.2c8d4a69fb9ec63496eb3c73f01b328d.svg";
export { ForwardRef as ReactComponent };